import { call, put, takeLatest, fork, all } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseReportListRequestParams } from '../utils/commonUtils';
import * as recommendationActions from '../actions/recommendationAction';
import * as recommendationService from './../services/recommendationService';

function* getRecommendation() {
    yield takeLatest(Types.GET_RECOMMENDATION_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseReportListRequestParams(action.params || {});
        const result = yield call(recommendationService.getRecommendation, params);
        yield put(recommendationActions.setRecommendationAction(result));
        // yield call(getAllData, result, params, recommendationService.getRecommendation, recommendationActions.setRecommendationAction)
    }, errorHandleReport(Types.GET_RECOMMENDATION_FAIL)))
}

function errorHandleReport(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'recommendation');
}

// function* getAllData(data = [], params = {}, funcService, funcSetDataCallback) {
//     const totalPage = Math.ceil(parseInt(data.totalCount) / parseInt(data.pageSize))
//     if(data.result.length > 0 && totalPage > 1) {
//         for(let page = 2; page <= totalPage; page++) {
//             if(!!funcService && !!funcSetDataCallback && !!params) {
//                 const nextData = yield call(funcService, { ...params, pageIndex: page });
//                 yield put(funcSetDataCallback(nextData));
//             }
//         }
//     }
// }  

export function* recommendationSaga() {
    yield all([
        fork(getRecommendation)
    ])
}
